import { Input } from "antd"
import React, { useState } from "react"

interface Props {
    value: any[]
    objects: any[]
    getLabel: (item: any) => string
    buildHref: (item: any) => string
    showSearch?: boolean
    maxHeight?: number
}

const ReadonlyMultiSelect: React.FC<Props> = ({ objects, getLabel, buildHref, showSearch, maxHeight = 260 }) => {
    const [search, setSearch] = useState("")

    if (!objects || objects.length === 0) {
        return <span className="text-gray-400 text-sm">—</span>
    }

    const filtered = showSearch && search.trim()
        ? objects.filter((item) => getLabel(item).toLowerCase().includes(search.toLowerCase()))
        : objects

    return (
        <div className="flex flex-col gap-1">
            {showSearch && (
                <Input
                    placeholder="Tìm theo tên hoặc SĐT..."
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    allowClear
                    className="mb-1"
                />
            )}
            <div
                className="flex flex-col gap-1 overflow-y-auto pr-1"
                style={{ maxHeight }}
            >
                {filtered.length === 0 ? (
                    <span className="text-gray-400 text-sm px-2">Không tìm thấy kết quả</span>
                ) : (
                    filtered.map((item) => (
                        <a
                            key={item.id}
                            href={buildHref(item)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#1677ff] hover:underline text-sm py-1 px-2 bg-gray-50 border border-gray-200 rounded block"
                        >
                            {getLabel(item)}
                        </a>
                    ))
                )}
            </div>
            {showSearch && filtered.length > 0 && (
                <span className="text-gray-400 text-xs mt-1">
                    {filtered.length}/{objects.length} đối tác
                </span>
            )}
        </div>
    )
}

export default ReadonlyMultiSelect